import EditTagContainer from "@containers/dashboard/tags/edit";
import { TagDefaultValue } from "@containers/dashboard/tags/edit/settings";
import DashboardLayout from "@layouts/dashboard";
import RoutesInstance from "@routes/instances";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

const EditTag = () => {
    const params = useParams();

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        ["getTag"],
        () =>
            Common.api.tags
                .GetSingle({
                    id: params.id || "",
                })
                .then((res) => res.data),
        {
            enabled: true,
            retry: false,
            onError: () => {
                Navigate(RoutesInstance.tags);
            },
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="ویرایش برچسب">
            <EditTagContainer
                data={data?.result || TagDefaultValue}
                loading={isLoading}
            />
        </DashboardLayout>
    );
};

export default EditTag;
